var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarnish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "varnish",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.573,
    height: 22.544,
    viewBox: "0 0 17.573 22.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1333",
    d: "M23.364,15.516h0a.662.662,0,0,0-.956,0C22.076,15.933,14.1,25.5,14.1,29.8c0,4.426,3.947,8.059,8.807,8.059s8.766-3.633,8.766-8.059C31.673,25.5,23.7,15.933,23.364,15.516Zm-.5,21.212c-4.154,0-7.561-3.132-7.561-6.932,0-3.341,5.858-10.857,7.6-12.986,1.7,2.13,7.561,9.646,7.561,12.986C30.468,33.6,27.062,36.728,22.866,36.728Z",
    transform: "translate(-14.1 -15.312)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarnish);
export default __webpack_public_path__ + "static/media/varnish.f51a50440110ad200e87f820446c1be6.svg";
export { ForwardRef as ReactComponent };